module.exports = ".textDec {\n  text-decoration: none; }\n\n.textRight {\n  text-align: right; }\n\n.mat-form-field {\n  width: 200px; }\n"